import styled from 'styled-components'

export const Container = styled.div`
  display: grid;
  grid-template-columns: 0.3fr 0.7fr;
  gap: ${props => props.theme.spacing.sp24};
  margin-top: ${props => props.theme.spacing.sp16};

  @media (max-width: 1120px) {
    grid-template-columns: 1fr;
  }
`

export const DataSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`
